module.exports = __webpack_public_path__ + "img/num1.dc6f5c74.svg";